import {Injectable} from '@angular/core';
import {Http, URLSearchParams} from '@angular/http';
import {Currency, Pool, PoolDetails} from '../entity';
import {Observable} from 'rxjs';

@Injectable()
export class PoolService {

    constructor(private http: Http) {}

    public getPoolsInfo(): Observable<Pool[]> {
        return this.http.get('/api/backoffice/pools')
            .map(response => response.json())
            .map((response: any[]) => response.map(pool => ({
                id: pool.id,
                name: pool.name,
                type: pool.type
            })));
    }

    public getBankPoolsInfo(couldCreateAccountUnderPool: boolean): Observable<Pool[]> {
        const search: URLSearchParams = new URLSearchParams;
        search.append('could_create_account', String(couldCreateAccountUnderPool));

        return this.http.get('/api/backoffice/pools/bank', {search})
            .map(response => response.json())
            .map((response: any[]) => response.map(pool => ({
                id: pool.id,
                name: pool.name,
                type: pool.type
            })));
    }

    public getFullPoolInfo(poolId: number): Observable<PoolDetails> {
        return this.http.get(`/api/backoffice/pools/${poolId}`)
            .map(response => response.json())
            .map((pool) => ({
                name: pool.name,
                type: pool.type,
                couldCreateAccountUnderPool: pool.couldCreateAccountUnder,
                senderInformation: pool.senderInformation
            }));
    }

    public getPoolCurrency(poolId: number): Observable<Array<Currency>> {
        return this.http.get(`/api/backoffice/pools/${poolId}/currencies`)
            .map(response => response.json());
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/pool.service.ts